import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';

import './style.scss';

const Rating = ({ ratingsCount, rating }) => {
    const count = ratingsCount < 1000 ? ratingsCount : '1k+';
    const ratingClassName = classNames('star-rating-s15', `rate-${Math.round(rating * 2)}`);
    const i18nKey = 'gig_page_perseus.seller_card.num_reviews';

    return (
        <div className="rating-wrapper">
            <span className={ratingClassName}/>
            <p className="rating-text">
                <strong>{rating.toFixed(1)}</strong> ({<I18n k={i18nKey} params={{ count }}/>})
            </p>
        </div>
    );
};

Rating.propTypes = {
    ratingsCount: PropTypes.number,
    rating: PropTypes.number
};

export default Rating;
